
//This class is used when we need to pull something from an api directly (e.g. in the store.)
export class RetrieveFromApi {
    static async getItems(api) {
        const items = await api.getAll();

        return items.data;
    }

    static async getItem(api, id) {
        const items = await api.get(id);
        return items.data;
    }
}